import React from "react";
import { Text } from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";

const textStyle = {
  display: "flex",
  alignItems: "start",
  textAlign: "start" as const,
  fontSize: "base",
  fontWeight: "semibold",
  padding: "0px",
  margin: "0px",
};

const StyledPiSealCheck: React.FC = () => <CheckIcon className="mr-2 w-5 h-5 mt-1" />;

const PremiumFeatures: React.FC = () => {
  return (
    <div className="flex flex-col flex-grow w-full gap-4 px-4">
      <div className="flex flex-row align-middle justify-center">
        <StyledPiSealCheck />
        <div className="flex flex-col gap-0">
          <Text {...textStyle}>Unlock Your Custom Learning Plan</Text>
          <Text className="text-sm" align={"start"}>
            Access the personalized study plan we've crafted just for you, designed to match your goals and learning style.
          </Text>
        </div>
      </div>
      <div className="flex flex-row align-middle">
        <StyledPiSealCheck />
        <div className="flex flex-col gap-0">
          <Text {...textStyle}>Learn Like a Native Speaker</Text>
          <Text className="text-sm" align={"start"}>
            Immerse yourself in authentic TV shows, YouTube videos, and real-world content you'll love.
          </Text>
        </div>
      </div>
      <div className="flex flex-row align-middle">
        <StyledPiSealCheck />
        <div className="flex flex-col gap-0">
          <Text {...textStyle}>Master New Words Effortlessly</Text>
          <Text className="text-sm" align={"start"}>
            Get instant translations as you watch and build your vocabulary naturally with your personal smart dictionary.
          </Text>
        </div>
      </div>
    </div>
  );
};

export default PremiumFeatures;
